import { ArrowUpRight } from "lucide-react";
import publications from "@/data/publications.json";
import "./OathboundPublications.css";

function formatPublicationDate(date) {
  if (!date) return "Date coming soon";

  const [year, month, day] = date.split("-").map(Number);
  const parsedDate = new Date(year, month - 1, day);

  return new Intl.DateTimeFormat("en", {
    month: "long",
    day: "numeric",
    year: "numeric",
  }).format(parsedDate);
}

/**
 * Renders every press mention as an editorial index rather than a card grid.
 * New entries can be appended directly to publications.json.
 */
export default function OathboundPublications() {
  return (
    <section
      id="publications"
      className="oathbound-publications"
      aria-labelledby="oathbound-publications-title"
    >
      <header className="oathbound-publications-header">
        <h2 id="oathbound-publications-title">What the Press Is Saying</h2>
      </header>

      <div className="oathbound-publications-list">
        {publications.map((article, index) => {
          const articleNumber = String(index + 1).padStart(2, "0");
          const hasArticleLink = article.url.startsWith("https://");

          return (
            <article
              className="oathbound-publication-entry"
              key={`${article.publication}-${index}`}
            >
              <div className="oathbound-publication-meta">
                <span aria-hidden="true">{articleNumber}</span>
                <h3>{article.publication}</h3>
                <time dateTime={article.date || undefined}>
                  {formatPublicationDate(article.date)}
                </time>
              </div>

              <blockquote>
                <p>{article.excerpt}</p>
              </blockquote>

              {hasArticleLink ? (
                <a
                  className="oathbound-publication-link"
                  href={article.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span>Read article</span>
                  <ArrowUpRight aria-hidden="true" />
                </a>
              ) : (
                <span
                  className="oathbound-publication-link-disabled"
                  aria-disabled="true"
                >
                  Article link coming soon
                </span>
              )}
            </article>
          );
        })}
      </div>
    </section>
  );
}
